import styled, { css } from 'styled-components';

import { Button } from 'components/Button';
import { pickColor } from 'themes/helpers/pickColor';

import { ModalBox, ModalContainer } from './types';

const Container = styled.div<ModalContainer>`
  position: fixed;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${({ hasLightOpacity }) =>
    hasLightOpacity ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.5)'};

  z-index: 1000;
`;

const Box = styled.div<ModalBox>`
  position: absolute;

  width: 50%;
  ${({ maxWidth }) => maxWidth && css`max-width: ${maxWidth};`}

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  background-color: ${pickColor('white')};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const BoxInner = styled.div`
  position: relative;

  padding: 1.5rem;
`;

const CloseButton = styled(Button)`
  position: absolute;

  top: 1.3rem;
  right: 1.5rem;
`;

export { Container, CloseButton, Box, BoxInner };
